/** Sabre CSL rate source codes (subset used by AXON). */
export const RATE_SOURCE_GDS = '100'
export const RATE_SOURCE_BOOKING_COM = '113'

export const RATE_SOURCE_LABELS = {
  [RATE_SOURCE_GDS]: 'Sabre GDS',
  [RATE_SOURCE_BOOKING_COM]: 'Booking.com'
}

/** Human-readable supplier label for advisors (e.g. "Sabre GDS", "Booking.com"). */
export function getRateSourceLabel(rateSource) {
  const code = String(rateSource ?? RATE_SOURCE_GDS)
  return RATE_SOURCE_LABELS[code] || RATE_SOURCE_LABELS[RATE_SOURCE_GDS]
}

/** Normalize code + label from a rate plan or cart line. */
export function resolveRateSourceFromPlan(planOrItem) {
  const rateSource = String(
    planOrItem?.rateSource ?? planOrItem?.RateSource ?? RATE_SOURCE_GDS
  )
  return {
    rateSource,
    rateSourceLabel: getRateSourceLabel(rateSource)
  }
}
